module.exports = __webpack_public_path__ + "static/media/general-de-seguros-parking-selected.68423ddf.svg";